import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-sheet_icon-50",
  "use": "icon-sheet_icon-50-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-sheet_icon-50\"><g transform=\"translate(-312 -146)\" stroke=\"currentColor\" fill=\"transparent\" stroke-width=\"1.5\"><rect x=\"313.75\" y=\"149.75\" width=\"20.5\" height=\"16.5\" rx=\"2\" /><path stroke-linecap=\"round\" d=\"M314.047 154h19.986M322.62 158h8M322.62 162h8M317.62 158h1M317.62 162h1\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol